export default __webpack_public_path__ + "static/media/IMGSVG1.18521482.svg";